/* Hannovae "Complete the look": the add-a-piece upsell under Add to cart.
   Markup: snippets/hnv-hanfu-pair.liquid. Tiles: snippets/hnv-look-card.liquid. Styles: assets/hnv-pair-it.css + inline.
   data-mode: "jacket" (a Hanfu page, the tiles are pieces), "piece" (Hanfu trousers or Draped Trousers, the tiles are
   Hanfu jackets) or "other" (the tiles are Hanfu jackets, no offer).
   The price cut is the Shopify automatic discount "Hanfu + any piece: 20% off the second". */
(function () {
  if (window.customElements.get('hnv-hanfu-pair')) return;
  var J = function (s, d) { try { return JSON.parse(s); } catch (e) { return d; } };
  var getJSON = function (url) { return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); };

  class HnvHanfuPair extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.pct = Number(this.dataset.pct) || 20;
      this.mode = this.dataset.mode || 'jacket';
      this.mainId = Number(this.dataset.mainProduct);
      this.jackets = J(this.dataset.jackets, []);
      this.mainOptions = J(this.dataset.mainOptions, []);
      this.mainVariants = J(this.dataset.mainVariants, []);
      this.mainIds = J(this.dataset.mainIds, []);
      this.statusEl = this.querySelector('[data-hnv-status]');
      this.cards = Array.prototype.map.call(this.querySelectorAll('[data-hnv-card]'), this.setupCard.bind(this));
      this.syncFromMain(true);
      this.refresh();
      var self = this;
      var more = this.querySelector('[data-hnv-more]');
      if (more) more.addEventListener('click', function () {
        Array.prototype.forEach.call(self.querySelectorAll('[data-hnv-extra]'), function (t) { t.hidden = false; });
        more.remove();
      });
      var scope = this.closest('.shopify-section') || document;
      var later = function () { setTimeout(function () { self.syncFromMain(false); }, 80); };
      scope.addEventListener('change', later);
      scope.addEventListener('click', later);
      document.addEventListener('krown:cart:add', function () { setTimeout(function () { self.refresh(); }, 600); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) self.refresh(); });
    }

    setupCard(el) {
      var card = {
        el: el,
        variants: J((el.querySelector('[data-hnv-variants]') || {}).textContent, []),
        opts: Array.prototype.slice.call(el.querySelectorAll('[data-hnv-opt]')),
        img: el.querySelector('[data-hnv-img]'),
        was: el.querySelector('[data-hnv-was]'),
        now: el.querySelector('[data-hnv-now]'),
        btn: el.querySelector('[data-hnv-add]'),
        label: el.querySelector('[data-hnv-label]'),
        variant: null
      };
      var self = this;
      card.opts.forEach(function (o) {
        if (o.tagName === 'SELECT') o.addEventListener('change', function () { o.setAttribute('data-touched', ''); self.updateCard(card); });
      });
      Array.prototype.forEach.call(el.querySelectorAll('[data-hnv-swatch]'), function (b) {
        b.addEventListener('click', function () {
          var inp = el.querySelector('input[data-hnv-opt="' + b.dataset.idx + '"]');
          if (!inp) return;
          inp.value = b.dataset.value;
          Array.prototype.forEach.call(el.querySelectorAll('[data-hnv-swatch][data-idx="' + b.dataset.idx + '"]'), function (s) { s.setAttribute('aria-pressed', s === b ? 'true' : 'false'); });
          var cn = el.querySelector('[data-hnv-cname]');
          if (cn) cn.textContent = b.dataset.value;
          self.updateCard(card);
        });
      });
      card.btn.addEventListener('click', function () { self.add(card); });
      this.updateCard(card);
      return card;
    }

    updateCard(card) {
      var vals = card.opts.map(function (o) { return o.value; });
      var v = card.variants.find(function (x) { return x.o.every(function (val, i) { return val === vals[i]; }); });
      card.variant = v || null;
      if (v) {
        if (card.img && v.i && card.img.getAttribute('src') !== v.i) card.img.src = v.i;
        if (card.was) card.was.textContent = v.w;
        if (card.now) card.now.textContent = v.n2;
      }
      card.btn.disabled = !(v && v.a);
      if (!v || !v.a) card.label.textContent = 'Sold out';
      else this.setLabel(card);
    }

    setLabel(card) {
      if (!card.variant || !card.variant.a) return;
      card.label.textContent = this.mainInCart ? 'Add' : 'Add both';
    }

    mainVariantId() {
      var form = document.getElementById(this.dataset.mainForm) || document.querySelector('form[id^="product-form-"][id$="-' + this.mainId + '"]');
      var input = form && form.querySelector('input[name="id"]');
      var id = input ? Number(input.value) : 0;
      return this.mainIds.indexOf(id) > -1 ? id : 0;
    }

    syncFromMain(first) {
      var id = this.mainVariantId(), i = this.mainIds.indexOf(id);
      var sel = i > -1 ? this.mainVariants[i] : null;
      if (!sel) return;
      var key = sel.join('|');
      if (!first && key === this._lastMain) return;
      this._lastMain = key;
      var names = this.mainOptions.map(function (n) { return String(n).toLowerCase(); });
      var sizeIdx = names.findIndex(function (n) { return /size|taille|größe/.test(n); });
      var self = this;
      this.cards.forEach(function (card) {
        var changed = false;
        card.opts.forEach(function (o) {
          if (o.tagName !== 'SELECT' || o.hasAttribute('data-touched') || sizeIdx < 0) return;
          var nm = String(o.getAttribute('data-hnv-opt-name') || '').toLowerCase();
          var want = sel[sizeIdx];
          var has = Array.prototype.some.call(o.options, function (op) { return op.value === want; });
          if (/size|taille|größe/.test(nm) && has && o.value !== want) { o.value = want; changed = true; }
        });
        if (changed || first) self.updateCard(card);
      });
    }

    refresh() {
      var self = this;
      return getJSON(this.dataset.cart + '.js').then(function (cart) { self.cart = cart; self.render(); }).catch(function () {});
    }

    render() {
      var items = (this.cart && this.cart.items) || [];
      var jackets = this.jackets, mainId = this.mainId, pct = this.pct;
      this.mainInCart = items.some(function (i) { return i.product_id === mainId; });
      var hasJacket = items.some(function (i) { return jackets.indexOf(i.handle) > -1; });
      var hasPiece = items.some(function (i) { return i.product_type === 'Essentials' || i.handle === 'draped-trousers'; });
      var off = '<strong>' + pct + '% off</strong>', msg = '';
      if (this.mode === 'piece') {
        var noun = this.dataset.noun || 'this piece', verb = this.dataset.verb || 'is';
        if (hasJacket && this.mainInCart) msg = off + ' is on for ' + noun + '.';
        else if (hasJacket) msg = 'Your Hanfu is in the bag, so ' + noun + ' ' + verb + ' ' + off + '.';
      } else if (this.mode === 'jacket') {
        if (hasJacket && hasPiece) msg = off + ' is on for your second piece.';
        else if (hasJacket) msg = 'Your Hanfu is in the bag. Add a piece below and it is ' + off + '.';
        else msg = 'Add any piece with this Hanfu and that piece is ' + off + '.';
      }
      if (this.statusEl) this.statusEl.innerHTML = msg;
      var self = this;
      this.cards.forEach(function (c) { self.setLabel(c); });
    }

    add(card) {
      if (this.busy || !card.variant || !card.variant.a) return;
      this.busy = true;
      var self = this, btn = card.btn;
      btn.classList.add('is-busy');
      getJSON(this.dataset.cart + '.js').catch(function () { return { items: [] }; }).then(function (cart) {
        var mainId = self.mainId;
        var mainInCart = (cart.items || []).some(function (i) { return i.product_id === mainId; });
        var items = [];
        if (!mainInCart) {
          var mv = self.mainVariantId();
          if (!mv) throw new Error('Pick your size above first.');
          items.push({ id: mv, quantity: 1 });
        }
        items.push({ id: card.variant.id, quantity: 1 });
        return fetch(self.dataset.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'That did not go into your bag. Try again.'); return j; });
        });
      }).then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        card.label.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-done'); self.setLabel(card); }, 2200);
        return self.openDrawer();
      }).then(function () { return self.refresh(); }).catch(function (e) {
        btn.classList.remove('is-busy');
        if (self.statusEl) self.statusEl.textContent = (e && e.message) || 'That did not go into your bag. Try again.';
      }).then(function () { self.busy = false; });
    }

    openDrawer() {
      var cartUrl = this.dataset.cart;
      return fetch('?section_id=helper-cart', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var f = document.getElementById('AjaxCartForm'), nf = doc.getElementById('AjaxCartForm');
        if (f && nf) { f.innerHTML = nf.innerHTML; if (typeof f.ajaxifyCartItems === 'function') f.ajaxifyCartItems(); }
        var s = document.getElementById('AjaxCartSubtotal'), ns = doc.getElementById('AjaxCartSubtotal');
        if (s && ns) s.innerHTML = ns.innerHTML;
        var cc = doc.querySelector('[data-cart-count]'), ct = doc.querySelector('[data-cart-total]');
        if (cc) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cc.textContent; });
        if (ct) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = ct.textContent; });
        var sb = document.getElementById('site-cart-sidebar');
        if (sb && typeof sb.show === 'function') {
          sb.show();
          if (window.KROWN && KROWN.functions && typeof KROWN.functions.eventDispatcher === 'function') KROWN.functions.eventDispatcher('krown:cart-sidebar:show', { sidebarElement: sb });
        } else {
          window.location.href = cartUrl;
        }
      }).catch(function () { window.location.href = cartUrl; });
    }
  }
  window.customElements.define('hnv-hanfu-pair', HnvHanfuPair);
})();